import { useMemo } from 'react';
import { capitalize } from '@hotjar/insights-common/lib/string';
import { useTranslation } from '@hotjar/translations';

export const useOperatingSystemName = (os: string): string => {
  const { t } = useTranslation('feedback');
  return useMemo(() => (os === 'Other' ? t('common.other') : capitalize(os, true)), [os, t]);
};
